import { render, staticRenderFns } from "./productTpye.vue?vue&type=template&id=f6ff4c1a&scoped=true"
import script from "./productTpye.vue?vue&type=script&lang=js"
export * from "./productTpye.vue?vue&type=script&lang=js"
import style0 from "./productTpye.vue?vue&type=style&index=0&id=f6ff4c1a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ff4c1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6ff4c1a')) {
      api.createRecord('f6ff4c1a', component.options)
    } else {
      api.reload('f6ff4c1a', component.options)
    }
    module.hot.accept("./productTpye.vue?vue&type=template&id=f6ff4c1a&scoped=true", function () {
      api.rerender('f6ff4c1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/components/productTpye.vue"
export default component.exports